import { DateTime } from "luxon";
import React from "react";

export function formatMaturityDate(props: {
  value: DateTime;
  timezone: string;
  format?: "full" | "short";
  locale?: "us" | "fr";
}) {
  const value = props.value.setZone(props.timezone).setLocale(props.locale ?? "us");

  if (props.format === "full" || props.format === undefined) {
    return value.toLocaleString(DateTime.DATE_MED);
  }

  return `${value.toLocaleString({ month: "short" })}' ${value.toLocaleString({
    year: "2-digit",
  })}`;
}

export const MaturityDateComponent: React.FC<{
  value: DateTime;
  timezone: string;
  format?: "full" | "short";
  locale?: "us" | "fr";
}> = (props) => <>{formatMaturityDate(props)}</>;
